import { getLockDateWarningText } from 'modules/common/selectors/requestSelectors.QBooks';
import FieldsSection from 'pages/requestList/components/FieldsSection';
import { memo } from 'react';

import { messages } from './QBooksJournalEntryFields.messages';
import { Root, StyledField } from './QBooksJournalEntryFields.styles';
import { QBooksJournalEntryFieldsProps } from './QBooksJournalEntryFields.types';

const QBooksJournalEntryFields = memo<QBooksJournalEntryFieldsProps>((props) => {
    const { request } = props;
    const { details } = request;

    const lockDateWarningText = getLockDateWarningText(request);

    return (
        <Root>
            <StyledField
                title={messages.journalDate}
                valueType={FieldsSection.Field.ValueType.Date}
                value={details.date}
                warningText={lockDateWarningText}
            />

            <StyledField
                title={messages.journalNumber}
                valueType={FieldsSection.Field.ValueType.String}
                value={details.number}
            />
        </Root>
    );
});

export default QBooksJournalEntryFields;
